import React, {useState} from 'react'
import { Box } from '@mui/material'

function TextBlock({id,type,properties,}) {
  return (
     <Box sx={{
           padding:  `${properties.padding.top}px ${properties.padding.right}px ${properties.padding.bottom}px ${properties.padding.left}px`,
           margin:  `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
           backgroundColor: properties.backgroundColor || 'transparent',
        }}>
     <Box
            component="p"
            sx={{
              textAlign: properties.textAlign || 'left',
              color: properties.color || '#000000',
              fontSize: properties.fontSize || '16px',
              fontWeight: properties.fontWeight || 'normal',
              fontFamily: properties.fontFamily || 'Arial, sans-serif',
              textDecoration: properties.textDecoration || 'none',
              lineHeight: properties.lineHeight || '1.5px',
              whiteSpace: 'pre-wrap'
            }}
           
          >
            {properties.content || 'Your text content here...'}
          </Box>
      </Box>
  )
}

export default TextBlock